import {api} from '../../../system/api';

export default {
    createBagSize: (params) => api.post('bag-sizes', {...params})
};
